import { render } from "./DeleteChildProjectsList.vue?vue&type=template&id=383d5457&scoped=true"
import script from "./DeleteChildProjectsList.vue?vue&type=script&lang=js"
export * from "./DeleteChildProjectsList.vue?vue&type=script&lang=js"

import "./DeleteChildProjectsList.vue?vue&type=style&index=0&id=383d5457&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383d5457"]])

export default __exports__